/*
    Copyright (C) 2017 Red Hat, Inc.

    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at

            http://www.apache.org/licenses/LICENSE-2.0

    Unless required by applicable law or agreed to in writing, software
    distributed under the License is distributed on an "AS IS" BASIS,
    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    See the License for the specific language governing permissions and
    limitations under the License.
*/
export const SOURCES_DRAGGABLE_TYPE = 'source';
export const SOURCES_HEIGHT_BOUNDARY_ID = 'sources-height';
export const SOURCES_WIDTH_BOUNDARY_ID = 'sources-width';
export const SOURCES_PROPERTIES_ID = 'sources-properties';
export const SOURCES_CONSTANTS_ID = 'sources-constants';
export const SOURCES_DOCUMENT_ID_PREFIX = 'sources-document-';
export const SOURCES_FIELD_ID_PREFIX = 'sources-field-';

export const MAPPINGS_DROP_TYPE = 'mapping';
export const MAPPINGS_HEIGHT_BOUNDARY_ID = 'mappings-height';
export const MAPPINGS_WIDTH_BOUNDARY_ID = 'mappings-width';
export const MAPPINGS_DOCUMENT_ID_PREFIX = 'mappings-document-';
export const MAPPINGS_FIELD_ID_PREFIX = 'mappings-field-';

export const TARGETS_DRAGGABLE_TYPE = 'target';
export const TARGETS_HEIGHT_BOUNDARY_ID = 'targets-height';
export const TARGETS_PROPERTIES_ID = 'targets-properties';
export const TARGETS_WIDTH_BOUNDARY_ID = 'targets-width';
export const TARGETS_DOCUMENT_ID_PREFIX = 'targets-document-';
export const TARGETS_FIELD_ID_PREFIX = 'targets-field-';
